import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { forwardRef } from 'react'

type GovUKTextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

export const GovUKTextarea = forwardRef<HTMLTextAreaElement, GovUKTextareaProps>(
  function GovUKTextarea({ className, ...props }, ref) {
    const classes = ['govuk-textarea', className].filter(Boolean).join(' ')
    return <textarea ref={ref} className={classes} {...props} />
  },
)
